import { useFormContext } from "react-hook-form";
import { JOB_STEPS } from "../CreateJobPage";
import CustomInputV2 from "@components/CustomInputV2/CustomInputV2";
import FieldError from "./FieldError";
import { JobFormValues } from "../schema/jobForm.schema";

const Step3 = ({ activeStep }) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<JobFormValues>();

  return (
    <>
      {/* Header */}
      <div className="flex border-b pb-3">
        <div className="flex flex-col gap-0.5 flex-1">
          <span className="text-xss font-bold text-light-black uppercase">
            Step {String(activeStep).padStart(2, "0")} /{" "}
            {JOB_STEPS[activeStep - 1]?.label}
          </span>
          <span className="font-semibold text-xl">
            {JOB_STEPS[activeStep - 1]?.title}
          </span>
          <span className="text-xss font-medium text-light-black">
            {JOB_STEPS[activeStep - 1]?.subtitle}
          </span>
        </div>
        <span className="self-end text-xss font-bold text-light-black uppercase leading-3">
          {JOB_STEPS[activeStep - 1]?.tagline}
        </span>
      </div>
      {/* Input sections */}
      <div className="flex flex-col gap-4 rounded-md border overflow-hidden mt-5 p-4">
        <div className="flex flex-col">
          <span className="font-bold text-xss text-slate-600">
            Job overview
          </span>
          <span className="text-xss font-medium text-light-black">
            Describe the opportunity, its purpose and how the successful
            candidate will contribute.
          </span>
          <textarea
            className={`border rounded-md mt-1.5 p-2 font-medium text-xs leading-5 ${errors.jobOverview ? "border-orange-700" : ""}`}
            rows={5}
            placeholder="Describe the role and its purpose."
            {...register("jobOverview")}
          />
          <FieldError message={errors.jobOverview?.message} />
        </div>

        <div className="flex flex-col">
          <span className="font-bold text-xss text-slate-600">
            Key responsibilities
          </span>
          <span className="text-xss font-medium text-light-black">
            Enter one candidate-facing responsibility per line.
          </span>
          <textarea
            className={`border rounded-md mt-1.5 p-2 font-medium text-xs leading-5 ${errors.keyResponsibilities ? "border-orange-700" : ""}`}
            rows={5}
            placeholder={"Monitor and investigate security events.\nSupport incident response activity."}
            {...register("keyResponsibilities")}
          />
          <FieldError message={errors.keyResponsibilities?.message} />
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="flex flex-col gap-1.5">
            <label className="text-xss font-bold text-slate-600">
              Industry
            </label>
            <CustomInputV2
              placeholder="Enter industry"
              inputContainerStyle={errors.industryType ? "border-orange-700" : ""}
              {...register("industryType")}
            />
            <FieldError message={errors.industryType?.message} />
          </div>
          <div className="flex flex-col gap-1.5">
            <label className="text-xss font-bold text-slate-600">
              Salary and benefits
            </label>
            <CustomInputV2
              placeholder="e.g. Pension and flexible working"
              {...register("salaryAndBenefits")}
            />
          </div>
        </div>
      </div>

      {/* Writing guidance */}
      <div className="flex items-center px-4 py-3.5 rounded-md border bg-slate-50 mt-5 gap-5">
        <span className="font-bold text-xss text-light-black shrink-0 uppercase tracking-wide">
          Writing guidance
        </span>
        <span className="text-xss font-medium text-light-black">
          Keep the public description factual and inclusive. The next stage
          captures measurable skill evidence separately so requirements do not
          become hidden inside prose.
        </span>
      </div>
    </>
  );
};

export default Step3;
